export function readRawConfigString(
	config: Record<string, unknown>,
	key: string
): string | undefined {
	const value = config[key];

	if (typeof value !== 'string' || value.length === 0) {
		return undefined;
	}

	return value.startsWith('PLACEHOLDER-') ? undefined : value;
}

export function readRawConfigBoolean(
	config: Record<string, unknown>,
	key: string
): boolean | undefined {
	const value = config[key];

	if (value === true || value === 'true') {
		return true;
	}

	if (value === false || value === 'false') {
		return false;
	}

	return undefined;
}
